import classNames from "classnames";
import PropTypes from "prop-types";

const IconHelp = ({ className, size = 20, ...props }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 20 20"
		fill="none"
		aria-hidden="true"
		focusable="false"
		className={classNames("icon-help", className)}
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1.04167 10.5C1.04167 5.55244 5.05246 1.54166 10 1.54166C14.9476 1.54166 18.9583 5.55244 18.9583 10.5C18.9583 15.4476 14.9476 19.4583 10 19.4583C5.05246 19.4583 1.04167 15.4476 1.04167 10.5ZM9.16667 14.25C9.16667 13.7897 9.53976 13.4167 10 13.4167H10.0075C10.4678 13.4167 10.8408 13.7897 10.8408 14.25C10.8408 14.7102 10.4678 15.0833 10.0075 15.0833H10C9.53976 15.0833 9.16667 14.7102 9.16667 14.25ZM9.16667 8.41666C9.16667 7.95642 9.53976 7.58332 10 7.58332C10.4603 7.58332 10.8333 7.95642 10.8333 8.41666C10.8333 8.5838 10.785 8.73711 10.7018 8.86641C10.6034 9.01932 10.4783 9.18057 10.3241 9.37216L10.2494 9.46466C10.1201 9.62449 9.97392 9.80541 9.84067 9.98849C9.52734 10.4192 9.16667 11.0153 9.16667 11.75C9.16667 12.2102 9.53976 12.5833 10 12.5833C10.4603 12.5833 10.8333 12.2102 10.8333 11.75C10.8333 11.5642 10.9249 11.3311 11.1883 10.9691C11.2943 10.8234 11.4087 10.6818 11.5374 10.5225L11.6226 10.417C11.7781 10.2237 11.9528 10.0023 12.1034 9.76824C12.3544 9.37807 12.5 8.91307 12.5 8.41666C12.5 7.03595 11.3808 5.91666 10 5.91666C8.61926 5.91666 7.50001 7.03595 7.50001 8.41666C7.50001 8.87691 7.8731 9.24999 8.33334 9.24999C8.79359 9.24999 9.16667 8.87691 9.16667 8.41666Z"
			fill="currentColor"
		/>
	</svg>
);

IconHelp.propTypes = {
	className: PropTypes.string,
	size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default IconHelp;
